import AbstractModule from './AbstractModule';

export default class extends AbstractModule {
    constructor(options) {
        super(options);

        this.currentRange = 0;
        this.$dom         = {};
        this.datas        = undefined;

        this.initParameters(options);
        this.init();
    }

    /**
     * Initialisation des paramètres.
     *
     */
    initParameters(options) {
        // options en paramètres
        this.DELAY        = options.delay || 10000;
        this.CARDS_NUMBER = options.number || 6;

         if (window.matchMedia('(max-width: 699px)').matches) {
            this.CARDS_NUMBER = 1;
         }

        if (window.matchMedia('(min-width: 700px)').matches &&
            window.matchMedia('(max-width: 999px)').matches) {
            this.CARDS_NUMBER = 2;
        }
    }

    /**
     * Initialisation.
     *
     */
    init() {
        // dom elements
        this.$dom.navigation = this.$el.find('.js-athletes-carousel-navigation');
        this.$dom.profil     = this.$el.find('.js-athletes-carousel-profil');
        this.$dom.lastname   = this.$el.find('.js-athletes-carousel-lastname');
        this.$dom.firstname  = this.$el.find('.js-athletes-carousel-firstname');
        this.$dom.location   = this.$el.find('.js-athletes-carousel-location');
        this.$dom.team       = this.$el.find('.js-athletes-carousel-team');
        this.$dom.twitter    = this.$el.find('.js-athletes-carousel-twitter');
        this.$dom.instagram  = this.$el.find('.js-athletes-carousel-instagram');
        this.$dom.website    = this.$el.find('.js-athletes-carousel-website');

        // activer les éléments du dom en fonction du
        // nombre de colonnes qui doivent être affichées
        for (let i = 0; i < this.CARDS_NUMBER; i += 1) {
            this.$dom.profil.eq(i).removeClass('u-hidden');
        }

        // initialiser des données
        this.initDatas();

        // initialiser les événements
        this.initEvent();

        // afficher les données
        this.updateDatas();
    }

    /**
     * Initialisation des événements.
     *
     */
    initEvent() {
        this.$el.on('click.AthletesCarousel', '.js-athletes-carousel-next', event => {
            event.preventDefault();
            this.nextRange();
        });

        this.$el.on('click.AthletesCarousel', '.js-athletes-carousel-prev', event => {
            event.preventDefault();
            this.prevRange();
        });
    }

    /**
     * Initialisation des données.
     *
     */
    initDatas() {
        this.datas = window.athletesOverseas;

        // désactiver les fléches si le nombre de cartes
        // est inférieur au nombre de slots disponibles
        if (this.CARDS_NUMBER >= this.datas.length) {
            this.$dom.navigation.addClass('u-hidden');
        }
    }

    /**
     * Mettre à jour le range devant être affiché.
     * (affichage des éléments suivants)
     *
     */
    nextRange() {
        if (this.datas.length > this.CARDS_NUMBER) {
            if ((this.currentRange + this.CARDS_NUMBER) >= this.datas.length) {
                this.currentRange = 0;
            } else {
                this.currentRange += this.CARDS_NUMBER;
            }

            this.updateDatas();
        }
    }

    /**
     * Mettre à jour le range devant être affiché.
     * (affichage des éléments précédents)
     *
     */
    prevRange() {
        if (this.datas.length > this.CARDS_NUMBER) {
            if (this.currentRange <= 0) {
                if (this.datas.length % this.CARDS_NUMBER === 0) {
                    this.currentRange = this.datas.length - this.CARDS_NUMBER;
                } else {
                    this.currentRange = this.datas.length - (this.datas.length % this.CARDS_NUMBER);
                }
            } else {
                this.currentRange -= this.CARDS_NUMBER;
            }

            this.updateDatas();
        }
    }

    /**
     * Mettre a jour l'affichage des données.
     *
     */
    updateDatas() {
        //ne pas afficher les éléments
        this.$el.removeClass('is-show-card');

        // mettre à jour les données
        setTimeout(() => {
            let cpt = 0;
            for (let i = this.currentRange; i < this.currentRange + this.CARDS_NUMBER; i += 1) {
                if (this.datas[i] !== undefined) {
                    this.$dom.lastname.eq(cpt).text(this.datas[i].lastname);
                    this.$dom.firstname.eq(cpt).text(this.datas[i].firstname);
                    this.$dom.location.eq(cpt).text(this.datas[i].location);
                    this.$dom.team.eq(cpt).text(this.datas[i].team);

                    if (typeof this.datas[i].twitter === 'string') {
                        const uri = `https://twitter.com/${this.datas[i].twitter}`;
                        this.$dom.twitter.eq(cpt).attr('href', uri).removeClass('-disable');
                    } else {
                        this.$dom.twitter.eq(cpt).removeAttr('href').addClass('-disable');
                    }

                    if (typeof this.datas[i].instagram === 'string') {
                        const uri = `https://instagram.com/${this.datas[i].instagram}`;
                        this.$dom.instagram.eq(cpt).attr('href', uri).removeClass('-disable');
                    } else {
                        this.$dom.instagram.eq(cpt).removeAttr('href').addClass('-disable');
                    }

                    if (typeof this.datas[i].website === 'string') {
                        this.$dom.website.eq(cpt).attr('href', this.datas[i].website).removeClass('-disable');
                    } else {
                        this.$dom.website.eq(cpt).removeAttr('href').addClass('-disable');
                    }
                } else {
                    this.$dom.lastname.eq(cpt).text('');
                    this.$dom.firstname.eq(cpt).text('');
                    this.$dom.location.eq(cpt).text('');
                    this.$dom.team.eq(cpt).text('');
                    this.$dom.twitter.eq(cpt).removeAttr('href').addClass('-disable');
                    this.$dom.instagram.eq(cpt).removeAttr('href').addClass('-disable');
                    this.$dom.website.eq(cpt).removeAttr('href').addClass('-disable');
                }
                cpt += 1;
            }

            this.$el.addClass('is-show-card');
        }, 800);
    }

    /**
     * Destructeur.
     *
     */
    destroy() {
        this.$el.off('.AthletesCarousel');

        this.delay = null;
        this.currentId = 0;
        this.$dom = {};
        this.datas = null;
    }
}
